window.mwCustomCurrencyList = [
    {
      label: 'USD',
      with_currency_format: '{{amount}} USD',
      name: 'US Dollar',
      symbol: '$',
      countryCodes: 'AS,EC,FM,GU,HT,IO,MH,MP,PA,PR,PW,SV,TC,UM,US,VG,VI,BQ,TL',
      baseCountryCode: 'us',
      emoji: '🇺🇸',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Euro',
      label: 'EUR',
      symbol: '€',
      with_currency_format: '{{amount_with_comma_separator}} EUR',
      countryCodes:
        'AD,AT,AX,BE,CY,DE,ES,FI,FR,GF,GP,GR,IE,IT,LU,MC,MQ,MT,NL,PM,PT,RE,SI,SK,SM,TF,VA,YT,EE,LV,LT,ME,BL,MF',
      baseCountryCode: 'eu',
      emoji: '🇪🇺',
      without_currency_format: '€{{amount_with_comma_separator}}',
    },
    {
      name: 'Pound Sterling',
      label: 'GBP',
      symbol: '£',
      with_currency_format: '{{amount}} GBP',
      countryCodes: 'GS,GB,JE,IM,SH',
      baseCountryCode: 'gb',
      emoji: '🇬🇧',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Australian Dollar',
      label: 'AUD',
      symbol: '$',
      with_currency_format: '{{amount}} AUD',
      countryCodes: 'AU,CX,CC,HM,KI,NR,NF,TV',
      baseCountryCode: 'au',
      emoji: '🇦🇺',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Yen',
      label: 'JPY',
      symbol: '¥',
      with_currency_format: '{{amount_no_decimals}} JPY',
      countryCodes: 'JP',
      baseCountryCode: 'jp',
      emoji: '🇯🇵',
      without_currency_format: '¥{{amount_no_decimals}}',
    },
    {
      name: 'Canadian Dollar',
      label: 'CAD',
      symbol: '$',
      with_currency_format: '{{amount}} CAD',
      countryCodes: 'CA',
      baseCountryCode: 'ca',
      emoji: '🇨🇦',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'UAE Dirham',
      label: 'AED',
      symbol: 'د.إ',
      with_currency_format: '{{amount}} AED',
      countryCodes: 'AE',
      baseCountryCode: 'ae',
      emoji: '🇦🇪',
      without_currency_format: 'د.إ{{amount}}',
    },
    {
      name: 'Afghani',
      label: 'AFN',
      symbol: 'Af',
      with_currency_format: '{{amount}} AFN',
      countryCodes: 'AF',
      baseCountryCode: 'af',
      emoji: '🇦🇫',
      without_currency_format: 'Af{{amount}}',
    },
    {
      name: 'Lek',
      label: 'ALL',
      symbol: 'Lek',
      with_currency_format: '{{amount}} ALL',
      countryCodes: 'AL',
      baseCountryCode: 'al',
      emoji: '🇦🇱',
      without_currency_format: 'Lek{{amount}}',
    },
    {
      name: 'Armenian Dram',
      label: 'AMD',
      symbol: '',
      with_currency_format: '{{amount}} AMD',
      countryCodes: 'AM',
      baseCountryCode: 'am',
      emoji: '🇦🇲',
      without_currency_format: '{{amount}}',
    },
    {
      name: 'Netherlands Antillean Guilder',
      label: 'ANG',
      symbol: 'ƒ',
      with_currency_format: '{{amount}} ANG',
      countryCodes: 'CW,SX',
      baseCountryCode: 'cw',
      emoji: '🇨🇼',
      without_currency_format: 'ƒ{{amount}}',
    },
    {
      name: 'Angolan Kwanza',
      label: 'AOA',
      symbol: 'Kz',
      with_currency_format: '{{amount}} AOA',
      countryCodes: 'AO',
      baseCountryCode: 'ao',
      emoji: '🇦🇴',
      without_currency_format: 'Kz{{amount}}',
    },
    {
      name: 'Argentine Peso',
      label: 'ARS',
      symbol: '$',
      with_currency_format: '{{amount_with_comma_separator}} ARS',
      countryCodes: 'AR',
      baseCountryCode: 'ar',
      emoji: '🇦🇷',
      without_currency_format: '${{amount_with_comma_separator}}',
    },
    {
      name: 'Aruban Florin',
      label: 'AWG',
      symbol: 'ƒ',
      with_currency_format: '{{amount}} AWG',
      countryCodes: 'AW',
      baseCountryCode: 'aw',
      emoji: '🇦🇼',
      without_currency_format: 'ƒ{{amount}}',
    },
    {
      name: 'Azerbaijanian Manat',
      label: 'AZN',
      symbol: 'ман',
      with_currency_format: '{{amount}} AZN',
      countryCodes: 'AZ',
      baseCountryCode: 'az',
      emoji: '🇦🇿',
      without_currency_format: 'ман{{amount}}',
    },
    {
      name: 'Convertible Mark',
      label: 'BAM',
      symbol: 'KM',
      with_currency_format: '{{amount_with_comma_separator}} BAM',
      countryCodes: 'BA',
      baseCountryCode: 'ba',
      emoji: '🇧🇦',
      without_currency_format: 'KM{{amount_with_comma_separator}}',
    },
    {
      name: 'Barbados Dollar',
      label: 'BBD',
      symbol: '$',
      with_currency_format: '{{amount}} BBD',
      countryCodes: 'BB',
      baseCountryCode: 'bb',
      emoji: '🇧🇧',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Taka',
      label: 'BDT',
      symbol: '৳',
      with_currency_format: '{{amount}} BDT',
      countryCodes: 'BD',
      baseCountryCode: 'bd',
      emoji: '🇧🇩',
      without_currency_format: '৳{{amount}}',
    },
    {
      name: 'Bulgarian Lev',
      label: 'BGN',
      symbol: 'лв',
      with_currency_format: '{{amount}} BGN',
      countryCodes: 'BG',
      baseCountryCode: 'bg',
      emoji: '🇧🇬',
      without_currency_format: 'лв{{amount}}',
    },
    {
      name: 'Bahraini Dinar',
      label: 'BHD',
      symbol: '.د.ب',
      with_currency_format: '{{amount}} BHD',
      countryCodes: 'BH',
      baseCountryCode: 'bh',
      emoji: '🇧🇭',
      without_currency_format: '.د.ب{{amount}}',
    },
    {
      name: 'Burundi Franc',
      label: 'BIF',
      symbol: 'FBu',
      with_currency_format: '{{amount}} BIF',
      countryCodes: 'BI',
      baseCountryCode: 'bi',
      emoji: '🇧🇮',
      without_currency_format: 'FBu{{amount}}',
    },
    {
      name: 'Bermudian Dollar',
      label: 'BMD',
      symbol: '$',
      with_currency_format: '{{amount}} BMD',
      countryCodes: 'BM',
      baseCountryCode: 'bm',
      emoji: '🇧🇲',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Brunei Dollar',
      label: 'BND',
      symbol: '$',
      with_currency_format: '{{amount}} BND',
      countryCodes: 'BN',
      baseCountryCode: 'bn',
      emoji: '🇧🇳',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Boliviano',
      label: 'BOB',
      symbol: '$b',
      with_currency_format: '{{amount_with_comma_separator}} BOB',
      countryCodes: 'BO',
      baseCountryCode: 'bo',
      emoji: '🇧🇴',
      without_currency_format: '$b{{amount_with_comma_separator}}',
    },
    {
      name: 'Brazilian Real',
      label: 'BRL',
      symbol: 'R$',
      with_currency_format: '{{amount_with_comma_separator}} BRL',
      countryCodes: 'BR',
      baseCountryCode: 'br',
      emoji: '🇧🇷',
      without_currency_format: 'R${{amount_with_comma_separator}}',
    },
    {
      name: 'Bahamian Dollar',
      label: 'BSD',
      symbol: '$',
      with_currency_format: '{{amount}} BSD',
      countryCodes: 'BS',
      baseCountryCode: 'bs',
      emoji: '🇧🇸',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Pula',
      label: 'BWP',
      symbol: 'P',
      with_currency_format: '{{amount}} BWP',
      countryCodes: 'BW',
      baseCountryCode: 'bw',
      emoji: '🇧🇼',
      without_currency_format: 'P{{amount}}',
    },
    {
      name: 'Belarussian Ruble',
      label: 'BYN',
      symbol: 'p.',
      with_currency_format: '{{amount}} BYN',
      countryCodes: 'BY',
      baseCountryCode: 'by',
      emoji: '🇧🇾',
      without_currency_format: 'p.{{amount}}',
    },
    {
      name: 'Belize Dollar',
      label: 'BZD',
      symbol: 'BZ$',
      with_currency_format: '{{amount}} BZD',
      countryCodes: 'BZ',
      baseCountryCode: 'bz',
      emoji: '🇧🇿',
      without_currency_format: 'BZ${{amount}}',
    },
    {
      name: 'Swiss Franc',
      label: 'CHF',
      symbol: 'CHF',
      with_currency_format: '{{amount}} CHF',
      countryCodes: 'LI,CH',
      baseCountryCode: 'ch',
      emoji: '🇨🇭',
      without_currency_format: 'CHF{{amount}}',
    },
    {
      name: 'Chilean Peso',
      label: 'CLP',
      symbol: '$',
      with_currency_format: '{{amount_no_decimals}} CLP',
      countryCodes: 'CL',
      baseCountryCode: 'cl',
      emoji: '🇨🇱',
      without_currency_format: '${{amount_no_decimals}}',
    },
    {
      name: 'Yuan Renminbi',
      label: 'CNY',
      symbol: '¥',
      with_currency_format: '{{amount}} CNY',
      countryCodes: 'CN',
      baseCountryCode: 'cn',
      emoji: '🇨🇳',
      without_currency_format: '¥{{amount}}',
    },
    {
      name: 'Colombian Peso',
      label: 'COP',
      symbol: '$',
      with_currency_format: '{{amount_with_comma_separator}} COP',
      countryCodes: 'CO',
      baseCountryCode: 'co',
      emoji: '🇨🇴',
      without_currency_format: '${{amount_with_comma_separator}}',
    },
    {
      name: 'Costa Rican Colon',
      label: 'CRC',
      symbol: '₡',
      with_currency_format: '{{amount_with_comma_separator}} CRC',
      countryCodes: 'CR',
      baseCountryCode: 'cr',
      emoji: '🇨🇷',
      without_currency_format: '₡{{amount_with_comma_separator}}',
    },
    {
      name: 'Cuban Peso',
      label: 'CUP',
      symbol: '⃌',
      with_currency_format: '{{amount}} CUP',
      countryCodes: 'CU',
      baseCountryCode: 'cu',
      emoji: '🇨🇺',
      without_currency_format: '⃌{{amount}}',
    },
    {
      name: 'Cabo Verde Escudo',
      label: 'CVE',
      symbol: '$',
      with_currency_format: '{{amount}} CVE',
      countryCodes: 'CV',
      baseCountryCode: 'cv',
      emoji: '🇨🇻',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Czech Koruna',
      label: 'CZK',
      symbol: 'Kč',
      with_currency_format: '{{amount_with_comma_separator}} CZK',
      countryCodes: 'CZ',
      baseCountryCode: 'cz',
      emoji: '🇨🇿',
      without_currency_format: 'Kč{{amount_with_comma_separator}}',
    },
    {
      name: 'Djibouti Franc',
      label: 'DJF',
      symbol: 'Fdj',
      with_currency_format: '{{amount}} DJF',
      countryCodes: 'DJ',
      baseCountryCode: 'dj',
      emoji: '🇩🇯',
      without_currency_format: 'Fdj{{amount}}',
    },
    {
      name: 'Danish Krone',
      label: 'DKK',
      symbol: 'kr',
      with_currency_format: '{{amount_with_comma_separator}} DKK',
      countryCodes: 'DK,FO,GL',
      baseCountryCode: 'dk',
      emoji: '🇩🇰',
      without_currency_format: 'kr{{amount_with_comma_separator}}',
    },
    {
      name: 'Dominican Peso',
      label: 'DOP',
      symbol: 'RD$',
      with_currency_format: '{{amount}} DOP',
      countryCodes: 'DO',
      baseCountryCode: 'do',
      emoji: '🇩🇴',
      without_currency_format: 'RD${{amount}}',
    },
    {
      name: 'Algerian Dinar',
      label: 'DZD',
      symbol: 'دج',
      with_currency_format: '{{amount}} DZD',
      countryCodes: 'DZ',
      baseCountryCode: 'dz',
      emoji: '🇩🇿',
      without_currency_format: 'دج{{amount}}',
    },
    {
      name: 'Egyptian Pound',
      label: 'EGP',
      symbol: '£',
      with_currency_format: '{{amount}} EGP',
      countryCodes: 'EG',
      baseCountryCode: 'eg',
      emoji: '🇪🇬',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Nakfa',
      label: 'ERN',
      symbol: '',
      with_currency_format: '{{amount}} ERN',
      countryCodes: 'ER',
      baseCountryCode: 'er',
      emoji: '🇪🇷',
      without_currency_format: '{{amount}}',
    },
    {
      name: 'Ethiopian Birr',
      label: 'ETB',
      symbol: 'Br',
      with_currency_format: '{{amount}} ETB',
      countryCodes: 'ET',
      baseCountryCode: 'et',
      emoji: '🇪🇹',
      without_currency_format: 'Br{{amount}}',
    },
    {
      name: 'Fiji Dollar',
      label: 'FJD',
      symbol: '$',
      with_currency_format: '{{amount}} FJD',
      countryCodes: 'FJ',
      baseCountryCode: 'fj',
      emoji: '🇫🇯',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Falkland Islands Pound',
      label: 'FKP',
      symbol: '£',
      with_currency_format: '{{amount}} FKP',
      countryCodes: 'FK',
      baseCountryCode: 'fk',
      emoji: '🇫🇰',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Georgian Lari',
      label: 'GEL',
      symbol: 'ლ',
      with_currency_format: '{{amount}} GEL',
      countryCodes: 'GE',
      baseCountryCode: 'ge',
      emoji: '🇬🇪',
      without_currency_format: 'ლ{{amount}}',
    },
    {
      name: 'Ghana Cedi',
      label: 'GHS',
      symbol: '¢',
      with_currency_format: '{{amount}} GHS',
      countryCodes: 'GH',
      baseCountryCode: 'gh',
      emoji: '🇬🇭',
      without_currency_format: '¢{{amount}}',
    },
    {
      name: 'Gibraltar Pound',
      label: 'GIP',
      symbol: '£',
      with_currency_format: '{{amount}} GIP',
      countryCodes: 'GI',
      baseCountryCode: 'gi',
      emoji: '🇬🇮',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Dalasi',
      label: 'GMD',
      symbol: 'D',
      with_currency_format: '{{amount}} GMD',
      countryCodes: 'GM',
      baseCountryCode: 'gm',
      emoji: '🇬🇲',
      without_currency_format: 'D{{amount}}',
    },
    {
      name: 'Guinea Franc',
      label: 'GNF',
      symbol: 'FG',
      with_currency_format: '{{amount}} GNF',
      countryCodes: 'GN',
      baseCountryCode: 'gn',
      emoji: '🇬🇳',
      without_currency_format: 'FG{{amount}}',
    },
    {
      name: 'Quetzal',
      label: 'GTQ',
      symbol: 'Q',
      with_currency_format: '{{amount}} GTQ',
      countryCodes: 'GT',
      baseCountryCode: 'gt',
      emoji: '🇬🇹',
      without_currency_format: 'Q{{amount}}',
    },
    {
      name: 'Guyana Dollar',
      label: 'GYD',
      symbol: '$',
      with_currency_format: '{{amount}} GYD',
      countryCodes: 'GY',
      baseCountryCode: 'gy',
      emoji: '🇬🇾',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Hong Kong Dollar',
      label: 'HKD',
      symbol: '$',
      with_currency_format: '{{amount}} HKD',
      countryCodes: 'HK',
      baseCountryCode: 'hk',
      emoji: '🇭🇰',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Lempira',
      label: 'HNL',
      symbol: 'L',
      with_currency_format: '{{amount}} HNL',
      countryCodes: 'HN',
      baseCountryCode: 'hn',
      emoji: '🇭🇳',
      without_currency_format: 'L{{amount}}',
    },
    {
      name: 'Croatian Kuna',
      label: 'HRK',
      symbol: 'kn',
      with_currency_format: '{{amount_with_comma_separator}} HRK',
      countryCodes: 'HR',
      baseCountryCode: 'hr',
      emoji: '🇭🇷',
      without_currency_format: 'kn{{amount_with_comma_separator}}',
    },
    {
      name: 'Haitian Gourde',
      label: 'HTG',
      symbol: 'G',
      with_currency_format: '{{amount_with_comma_separator}} HTG',
      countryCodes: 'HT',
      baseCountryCode: 'ht',
      emoji: '🇭🇹',
      without_currency_format: 'G{{amount_with_comma_separator}}',
    },
    {
      name: 'Forint',
      label: 'HUF',
      symbol: 'Ft',
      with_currency_format: '{{amount_no_decimals_with_comma_separator}} HUF',
      countryCodes: 'HU',
      baseCountryCode: 'hu',
      emoji: '🇭🇺',
      without_currency_format: 'Ft{{amount_no_decimals_with_comma_separator}}',
    },
    {
      name: 'Rupiah',
      label: 'IDR',
      symbol: 'Rp',
      with_currency_format: '{{amount_with_comma_separator}} IDR',
      countryCodes: 'ID',
      baseCountryCode: 'id',
      emoji: '🇮🇩',
      without_currency_format: 'Rp{{amount_with_comma_separator}}',
    },
    {
      name: 'New Israeli Sheqel',
      label: 'ILS',
      symbol: '₪',
      with_currency_format: '{{amount}} ILS',
      countryCodes: 'IL',
      baseCountryCode: 'il',
      emoji: '🇮🇱',
      without_currency_format: '₪{{amount}}',
    },
    {
      name: 'Indian Rupee',
      label: 'INR',
      symbol: '₹',
      with_currency_format: '{{amount}} INR',
      countryCodes: 'IN,BT',
      baseCountryCode: 'in',
      emoji: '🇮🇳',
      without_currency_format: '₹{{amount}}',
    },
    {
      name: 'Iraqi Dinar',
      label: 'IQD',
      symbol: 'ع.د',
      with_currency_format: '{{amount}} IQD',
      countryCodes: 'IQ',
      baseCountryCode: 'iq',
      emoji: '🇮🇶',
      without_currency_format: 'ع.د{{amount}}',
    },
    {
      name: 'Iranian Rial',
      label: 'IRR',
      symbol: '﷼',
      with_currency_format: '{{amount}} IRR',
      countryCodes: 'IR',
      baseCountryCode: 'ir',
      emoji: '🇮🇷',
      without_currency_format: '﷼{{amount}}',
    },
    {
      name: 'Iceland Krona',
      label: 'ISK',
      symbol: 'kr',
      with_currency_format: '{{amount_no_decimals}} ISK',
      countryCodes: 'IS',
      baseCountryCode: 'is',
      emoji: '🇮🇸',
      without_currency_format: 'kr{{amount_no_decimals}}',
    },
    {
      name: 'Jamaican Dollar',
      label: 'JMD',
      symbol: 'J$',
      with_currency_format: '{{amount}} JMD',
      countryCodes: 'JM',
      baseCountryCode: 'jm',
      emoji: '🇯🇲',
      without_currency_format: 'J${{amount}}',
    },
    {
      name: 'Jordanian Dinar',
      label: 'JOD',
      symbol: 'JD',
      with_currency_format: '{{amount}} JOD',
      countryCodes: 'JO',
      baseCountryCode: 'jo',
      emoji: '🇯🇴',
      without_currency_format: 'JD{{amount}}',
    },
    {
      name: 'Kenyan Shilling',
      label: 'KES',
      symbol: 'KSh',
      with_currency_format: '{{amount}} KES',
      countryCodes: 'KE',
      baseCountryCode: 'ke',
      emoji: '🇰🇪',
      without_currency_format: 'KSh{{amount}}',
    },
    {
      name: 'Som',
      label: 'KGS',
      symbol: 'лв',
      with_currency_format: '{{amount}} KGS',
      countryCodes: 'KG',
      baseCountryCode: 'kg',
      emoji: '🇰🇬',
      without_currency_format: 'лв{{amount}}',
    },
    {
      name: 'Riel',
      label: 'KHR',
      symbol: '៛',
      with_currency_format: '{{amount}} KHR',
      countryCodes: 'KH',
      baseCountryCode: 'kh',
      emoji: '🇰🇭',
      without_currency_format: '៛{{amount}}',
    },
    {
      name: 'Comoro Franc',
      label: 'KMF',
      symbol: 'CF',
      with_currency_format: '{{amount}} KMF',
      countryCodes: 'KM',
      baseCountryCode: 'km',
      emoji: '🇰🇲',
      without_currency_format: 'CF{{amount}}',
    },
    {
      name: 'North Korean Won',
      label: 'KPW',
      symbol: '₩',
      with_currency_format: '{{amount}} KPW',
      countryCodes: 'KP',
      baseCountryCode: 'kp',
      emoji: '🇰🇵',
      without_currency_format: '₩{{amount}}',
    },
    {
      name: 'Won',
      label: 'KRW',
      symbol: '₩',
      with_currency_format: '{{amount_no_decimals}} KRW',
      countryCodes: 'KR',
      baseCountryCode: 'kr',
      emoji: '🇰🇷',
      without_currency_format: '₩{{amount_no_decimals}}',
    },
    {
      name: 'Kuwaiti Dinar',
      label: 'KWD',
      symbol: 'د.ك',
      with_currency_format: '{{amount}} KWD',
      countryCodes: 'KW',
      baseCountryCode: 'kw',
      emoji: '🇰🇼',
      without_currency_format: 'د.ك{{amount}}',
    },
    {
      name: 'Cayman Islands Dollar',
      label: 'KYD',
      symbol: '$',
      with_currency_format: '{{amount}} KYD',
      countryCodes: 'KY',
      baseCountryCode: 'ky',
      emoji: '🇰🇾',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Tenge',
      label: 'KZT',
      symbol: 'лв',
      with_currency_format: '{{amount}} KZT',
      countryCodes: 'KZ',
      baseCountryCode: 'kz',
      emoji: '🇰🇿',
      without_currency_format: 'лв{{amount}}',
    },
    {
      name: 'Kip',
      label: 'LAK',
      symbol: '₭',
      with_currency_format: '{{amount}} LAK',
      countryCodes: 'LA',
      baseCountryCode: 'la',
      emoji: '🇱🇦',
      without_currency_format: '₭{{amount}}',
    },
    {
      name: 'Lebanese Pound',
      label: 'LBP',
      symbol: '£',
      with_currency_format: '{{amount}} LBP',
      countryCodes: 'LB',
      baseCountryCode: 'lb',
      emoji: '🇱🇧',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Sri Lanka Rupee',
      label: 'LKR',
      symbol: '₨',
      with_currency_format: '{{amount}} LKR',
      countryCodes: 'LK',
      baseCountryCode: 'lk',
      emoji: '🇱🇰',
      without_currency_format: '₨{{amount}}',
    },
    {
      name: 'Liberian Dollar',
      label: 'LRD',
      symbol: '$',
      with_currency_format: '{{amount}} LRD',
      countryCodes: 'LR',
      baseCountryCode: 'lr',
      emoji: '🇱🇷',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Lesotho Loti',
      label: 'LSL',
      symbol: 'L',
      with_currency_format: '{{amount}} LSL',
      countryCodes: 'LS',
      baseCountryCode: 'ls',
      emoji: '🇱🇸',
      without_currency_format: 'L{{amount}}',
    },
    {
      name: 'Libyan Dinar',
      label: 'LYD',
      symbol: 'ل.د',
      with_currency_format: '{{amount}} LYD',
      countryCodes: 'LY',
      baseCountryCode: 'ly',
      emoji: '🇱🇾',
      without_currency_format: 'ل.د{{amount}}',
    },
    {
      name: 'Moroccan Dirham',
      label: 'MAD',
      symbol: 'د.م.',
      with_currency_format: '{{amount}} MAD',
      countryCodes: 'MA,EH',
      baseCountryCode: 'ma',
      emoji: '🇲🇦',
      without_currency_format: 'د.م.{{amount}}',
    },
    {
      name: 'Moldovan Leu',
      label: 'MDL',
      symbol: 'L',
      with_currency_format: '{{amount}} MDL',
      countryCodes: 'MD',
      baseCountryCode: 'md',
      emoji: '🇲🇩',
      without_currency_format: 'L{{amount}}',
    },
    {
      name: 'Malagasy Ariary',
      label: 'MGA',
      symbol: 'Ar',
      with_currency_format: '{{amount}} MGA',
      countryCodes: 'MG',
      baseCountryCode: 'mg',
      emoji: '🇲🇬',
      without_currency_format: 'Ar{{amount}}',
    },
    {
      name: 'Denar',
      label: 'MKD',
      symbol: 'ден',
      with_currency_format: '{{amount}} MKD',
      countryCodes: 'MK',
      baseCountryCode: 'mk',
      emoji: '🇲🇰',
      without_currency_format: 'ден{{amount}}',
    },
    {
      name: 'Kyat',
      label: 'MMK',
      symbol: 'K',
      with_currency_format: '{{amount}} MMK',
      countryCodes: 'MM',
      baseCountryCode: 'mm',
      emoji: '🇲🇲',
      without_currency_format: 'K{{amount}}',
    },
    {
      name: 'Tugrik',
      label: 'MNT',
      symbol: '₮',
      with_currency_format: '{{amount_no_decimals}} MNT',
      countryCodes: 'MN',
      baseCountryCode: 'mn',
      emoji: '🇲🇳',
      without_currency_format: '₮{{amount_no_decimals}}',
    },
    {
      name: 'Pataca',
      label: 'MOP',
      symbol: 'MOP$',
      with_currency_format: '{{amount}} MOP',
      countryCodes: 'MO',
      baseCountryCode: 'mo',
      emoji: '🇲🇴',
      without_currency_format: 'MOP${{amount}}',
    },
    {
      name: 'Ouguiya',
      label: 'MRO',
      symbol: 'UM',
      with_currency_format: '{{amount}} MRO',
      countryCodes: 'MR',
      baseCountryCode: 'mr',
      emoji: '🇲🇷',
      without_currency_format: 'UM{{amount}}',
    },
    {
      name: 'Mauritius Rupee',
      label: 'MUR',
      symbol: '₨',
      with_currency_format: '{{amount}} MUR',
      countryCodes: 'MU',
      baseCountryCode: 'mu',
      emoji: '🇲🇺',
      without_currency_format: '₨{{amount}}',
    },
    {
      name: 'Rufiyaa',
      label: 'MVR',
      symbol: '.ރ',
      with_currency_format: '{{amount}} MVR',
      countryCodes: 'MV',
      baseCountryCode: 'mv',
      emoji: '🇲🇻',
      without_currency_format: '.ރ{{amount}}',
    },
    {
      name: 'Kwacha',
      label: 'MWK',
      symbol: 'MK',
      with_currency_format: '{{amount}} MWK',
      countryCodes: 'MW',
      baseCountryCode: 'mw',
      emoji: '🇲🇼',
      without_currency_format: 'MK{{amount}}',
    },
    {
      name: 'Mexican Peso',
      label: 'MXN',
      symbol: '$',
      with_currency_format: '{{amount}} MXN',
      countryCodes: 'MX',
      baseCountryCode: 'mx',
      emoji: '🇲🇽',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Malaysian Ringgit',
      label: 'MYR',
      symbol: 'RM',
      with_currency_format: '{{amount}} MYR',
      countryCodes: 'MY',
      baseCountryCode: 'my',
      emoji: '🇲🇾',
      without_currency_format: 'RM{{amount}}',
    },
    {
      name: 'Mozambique Metical',
      label: 'MZN',
      symbol: 'MT',
      with_currency_format: '{{amount}} MZN',
      countryCodes: 'MZ',
      baseCountryCode: 'mz',
      emoji: '🇲🇿',
      without_currency_format: 'MT{{amount}}',
    },
    {
      name: 'Namibian Dollar',
      label: 'NAD',
      symbol: '$',
      with_currency_format: '{{amount}} NAD',
      countryCodes: 'NA',
      baseCountryCode: 'na',
      emoji: '🇳🇦',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Naira',
      label: 'NGN',
      symbol: '₦',
      with_currency_format: '{{amount}} NGN',
      countryCodes: 'NG',
      baseCountryCode: 'ng',
      emoji: '🇳🇬',
      without_currency_format: '₦{{amount}}',
    },
    {
      name: 'Cordoba Oro',
      label: 'NIO',
      symbol: 'C$',
      with_currency_format: '{{amount}} NIO',
      countryCodes: 'NI',
      baseCountryCode: 'ni',
      emoji: '🇳🇮',
      without_currency_format: 'C${{amount}}',
    },
    {
      name: 'Norwegian Krone',
      label: 'NOK',
      symbol: 'kr',
      with_currency_format: '{{amount_with_comma_separator}} NOK',
      countryCodes: 'BV,NO,SJ',
      baseCountryCode: 'bv',
      emoji: '🇧🇻',
      without_currency_format: 'kr{{amount_with_comma_separator}}',
    },
    {
      name: 'Nepalese Rupee',
      label: 'NPR',
      symbol: '₨',
      with_currency_format: '{{amount}} NPR',
      countryCodes: 'NP',
      baseCountryCode: 'np',
      emoji: '🇳🇵',
      without_currency_format: '₨{{amount}}',
    },
    {
      name: 'New Zealand Dollar',
      label: 'NZD',
      symbol: '$',
      with_currency_format: '{{amount}} NZD',
      countryCodes: 'CK,NZ,NU,PN,TK',
      baseCountryCode: 'ck',
      emoji: '🇨🇰',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Rial Omani',
      label: 'OMR',
      symbol: '﷼',
      with_currency_format: '{{amount_with_comma_separator}} OMR',
      countryCodes: 'OM',
      baseCountryCode: 'om',
      emoji: '🇴🇲',
      without_currency_format: '﷼{{amount_with_comma_separator}}',
    },
    {
      name: 'Nuevo Sol',
      label: 'PEN',
      symbol: 'S/.',
      with_currency_format: '{{amount}} PEN',
      countryCodes: 'PE',
      baseCountryCode: 'pe',
      emoji: '🇵🇪',
      without_currency_format: 'S/.{{amount}}',
    },
    {
      name: 'Kina',
      label: 'PGK',
      symbol: 'K',
      with_currency_format: '{{amount}} PGK',
      countryCodes: 'PG',
      baseCountryCode: 'pg',
      emoji: '🇵🇬',
      without_currency_format: 'K{{amount}}',
    },
    {
      name: 'Philippine Peso',
      label: 'PHP',
      symbol: '₱',
      with_currency_format: '{{amount}} PHP',
      countryCodes: 'PH',
      baseCountryCode: 'ph',
      emoji: '🇵🇭',
      without_currency_format: '₱{{amount}}',
    },
    {
      name: 'Pakistan Rupee',
      label: 'PKR',
      symbol: '₨',
      with_currency_format: '{{amount}} PKR',
      countryCodes: 'PK',
      baseCountryCode: 'pk',
      emoji: '🇵🇰',
      without_currency_format: '₨{{amount}}',
    },
    {
      name: 'Zloty',
      label: 'PLN',
      symbol: 'zł',
      with_currency_format: '{{amount_with_comma_separator}} PLN',
      countryCodes: 'PL',
      baseCountryCode: 'pl',
      emoji: '🇵🇱',
      without_currency_format: 'zł{{amount_with_comma_separator}}',
    },
    {
      name: 'Guarani',
      label: 'PYG',
      symbol: 'Gs',
      with_currency_format: '{{amount_no_decimals_with_comma_separator}} PYG',
      countryCodes: 'PY',
      baseCountryCode: 'py',
      emoji: '🇵🇾',
      without_currency_format: 'Gs{{amount_no_decimals_with_comma_separator}}',
    },
    {
      name: 'Qatari Rial',
      label: 'QAR',
      symbol: '﷼',
      with_currency_format: '{{amount_with_comma_separator}} QAR',
      countryCodes: 'QA',
      baseCountryCode: 'qa',
      emoji: '🇶🇦',
      without_currency_format: '﷼{{amount_with_comma_separator}}',
    },
    {
      name: 'New Romanian Leu',
      label: 'RON',
      symbol: 'lei',
      with_currency_format: '{{amount}} RON',
      countryCodes: 'RO',
      baseCountryCode: 'ro',
      emoji: '🇷🇴',
      without_currency_format: 'lei{{amount}}',
    },
    {
      name: 'Serbian Dinar',
      label: 'RSD',
      symbol: 'Дин.',
      with_currency_format: '{{amount}} RSD',
      countryCodes: 'RS',
      baseCountryCode: 'rs',
      emoji: '🇷🇸',
      without_currency_format: 'Дин.{{amount}}',
    },
    {
      name: 'Russian Ruble',
      label: 'RUB',
      symbol: 'руб',
      with_currency_format: '{{amount_with_comma_separator}} RUB',
      countryCodes: 'RU',
      baseCountryCode: 'ru',
      emoji: '🇷🇺',
      without_currency_format: 'руб{{amount_with_comma_separator}}',
    },
    {
      name: 'Rwanda Franc',
      label: 'RWF',
      symbol: '',
      with_currency_format: '{{amount_no_decimals}} RWF',
      countryCodes: 'RW',
      baseCountryCode: 'rw',
      emoji: '🇷🇼',
      without_currency_format: '{{amount_no_decimals}}',
    },
    {
      name: 'Saudi Riyal',
      label: 'SAR',
      symbol: '﷼',
      with_currency_format: '{{amount}} SAR',
      countryCodes: 'SA',
      baseCountryCode: 'sa',
      emoji: '🇸🇦',
      without_currency_format: '﷼{{amount}}',
    },
    {
      name: 'Solomon Islands Dollar',
      label: 'SBD',
      symbol: '$',
      with_currency_format: '{{amount}} SBD',
      countryCodes: 'SB',
      baseCountryCode: 'sb',
      emoji: '🇸🇧',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Seychelles Rupee',
      label: 'SCR',
      symbol: '₨',
      with_currency_format: '{{amount}} SCR',
      countryCodes: 'SC',
      baseCountryCode: 'sc',
      emoji: '🇸🇨',
      without_currency_format: '₨{{amount}}',
    },
    {
      name: 'Sudanese Pound',
      label: 'SDG',
      symbol: '£',
      with_currency_format: '{{amount}} SDG',
      countryCodes: 'SD',
      baseCountryCode: 'sd',
      emoji: '🇸🇩',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Swedish Krona',
      label: 'SEK',
      symbol: 'kr',
      with_currency_format: '{{amount_with_comma_separator}} SEK',
      countryCodes: 'SE',
      baseCountryCode: 'se',
      emoji: '🇸🇪',
      without_currency_format: 'kr{{amount_with_comma_separator}}',
    },
    {
      name: 'Singapore Dollar',
      label: 'SGD',
      symbol: '$',
      with_currency_format: '{{amount}} SGD',
      countryCodes: 'SG',
      baseCountryCode: 'sg',
      emoji: '🇸🇬',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Saint Helena Pound',
      label: 'SHP',
      symbol: '£',
      with_currency_format: '{{amount}} SHP',
      countryCodes: 'SH',
      baseCountryCode: 'sh',
      emoji: '🇸🇭',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Leone',
      label: 'SLL',
      symbol: 'Le',
      with_currency_format: '{{amount}} SLL',
      countryCodes: 'SL',
      baseCountryCode: 'sl',
      emoji: '🇸🇱',
      without_currency_format: 'Le{{amount}}',
    },
    {
      name: 'Somali Shilling',
      label: 'SOS',
      symbol: 'S',
      with_currency_format: '{{amount}} SOS',
      countryCodes: 'SO',
      baseCountryCode: 'so',
      emoji: '🇸🇴',
      without_currency_format: 'S{{amount}}',
    },
    {
      name: 'Surinam Dollar',
      label: 'SRD',
      symbol: '$',
      with_currency_format: '{{amount}} SRD',
      countryCodes: 'SR',
      baseCountryCode: 'sr',
      emoji: '🇸🇷',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'Dobra',
      label: 'STD',
      symbol: 'Db',
      with_currency_format: '{{amount}} STD',
      countryCodes: 'ST',
      baseCountryCode: 'st',
      emoji: '🇸🇹',
      without_currency_format: 'Db{{amount}}',
    },
    {
      name: 'Syrian Pound',
      label: 'SYP',
      symbol: '£',
      with_currency_format: '{{amount}} SYP',
      countryCodes: 'SY',
      baseCountryCode: 'sy',
      emoji: '🇸🇾',
      without_currency_format: '£{{amount}}',
    },
    {
      name: 'Swazi Lilangeni',
      label: 'SZL',
      symbol: 'L',
      with_currency_format: '{{amount}} SZL',
      countryCodes: 'SZ',
      baseCountryCode: 'sz',
      emoji: '🇸🇿',
      without_currency_format: 'L{{amount}}',
    },
    {
      name: 'Baht',
      label: 'THB',
      symbol: '฿',
      with_currency_format: '{{amount}} THB',
      countryCodes: 'TH',
      baseCountryCode: 'th',
      emoji: '🇹🇭',
      without_currency_format: '฿{{amount}}',
    },
    {
      name: 'Somoni',
      label: 'TJS',
      symbol: 'TJS',
      with_currency_format: '{{amount}} TJS',
      countryCodes: 'TJ',
      baseCountryCode: 'tj',
      emoji: '🇹🇯',
      without_currency_format: 'TJS{{amount}}',
    },
    {
      name: 'Turkmenistan New Manat',
      label: 'TMT',
      symbol: 'm',
      with_currency_format: '{{amount}} TMT',
      countryCodes: 'TM',
      baseCountryCode: 'tm',
      emoji: '🇹🇲',
      without_currency_format: 'm{{amount}}',
    },
    {
      name: 'Tunisian Dinar',
      label: 'TND',
      symbol: 'د.ت',
      with_currency_format: '{{amount}} TND',
      countryCodes: 'TN',
      baseCountryCode: 'tn',
      emoji: '🇹🇳',
      without_currency_format: 'د.ت{{amount}}',
    },
    {
      name: 'Pa’anga',
      label: 'TOP',
      symbol: 'T$',
      with_currency_format: '{{amount}} TOP',
      countryCodes: 'TO',
      baseCountryCode: 'to',
      emoji: '🇹🇴',
      without_currency_format: 'T${{amount}}',
    },
    {
      name: 'Turkish Lira',
      label: 'TRY',
      symbol: '₺',
      with_currency_format: '{{amount}} TRY',
      countryCodes: 'TR',
      baseCountryCode: 'tr',
      emoji: '🇹🇷',
      without_currency_format: '₺{{amount}}',
    },
    {
      name: 'Trinidad and Tobago Dollar',
      label: 'TTD',
      symbol: '$',
      with_currency_format: '{{amount}} TTD',
      countryCodes: 'TT',
      baseCountryCode: 'tt',
      emoji: '🇹🇹',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'New Taiwan Dollar',
      label: 'TWD',
      symbol: 'NT$',
      with_currency_format: '{{amount}} TWD',
      countryCodes: 'TW',
      baseCountryCode: 'tw',
      emoji: '🇹🇼',
      without_currency_format: 'NT${{amount}}',
    },
    {
      name: 'Tanzanian Shilling',
      label: 'TZS',
      symbol: '',
      with_currency_format: '{{amount}} TZS',
      countryCodes: 'TZ',
      baseCountryCode: 'tz',
      emoji: '🇹🇿',
      without_currency_format: '{{amount}}',
    },
    {
      name: 'Hryvnia',
      label: 'UAH',
      symbol: '₴',
      with_currency_format: '{{amount}} UAH',
      countryCodes: 'UA',
      baseCountryCode: 'ua',
      emoji: '🇺🇦',
      without_currency_format: '₴{{amount}}',
    },
    {
      name: 'Uganda Shilling',
      label: 'UGX',
      symbol: 'USh',
      with_currency_format: '{{amount_no_decimals}} UGX',
      countryCodes: 'UG',
      baseCountryCode: 'ug',
      emoji: '🇺🇬',
      without_currency_format: 'USh{{amount_no_decimals}}',
    },
    {
      name: 'Peso Uruguayo',
      label: 'UYU',
      symbol: '$U',
      with_currency_format: '{{amount_with_comma_separator}} UYU',
      countryCodes: 'UY',
      baseCountryCode: 'uy',
      emoji: '🇺🇾',
      without_currency_format: '$U{{amount_with_comma_separator}}',
    },
    {
      name: 'Uzbekistan Sum',
      label: 'UZS',
      symbol: 'лв',
      with_currency_format: '{{amount}} UZS',
      countryCodes: 'UZ',
      baseCountryCode: 'uz',
      emoji: '🇺🇿',
      without_currency_format: 'лв{{amount}}',
    },
    {
      name: 'Bolivar',
      label: 'VEF',
      symbol: 'Bs',
      with_currency_format: '{{amount_with_comma_separator}} VEF',
      countryCodes: 'VE',
      baseCountryCode: 've',
      emoji: '🇻🇪',
      without_currency_format: 'Bs{{amount_with_comma_separator}}',
    },
    {
      name: 'Dong',
      label: 'VND',
      symbol: '₫',
      with_currency_format: '{{amount_no_decimals_with_comma_separator}} VND',
      countryCodes: 'VN',
      baseCountryCode: 'vn',
      emoji: '🇻🇳',
      without_currency_format: '₫{{amount_no_decimals_with_comma_separator}}',
    },
    {
      name: 'Vatu',
      label: 'VUV',
      symbol: 'VT',
      with_currency_format: '{{amount}} VUV',
      countryCodes: 'VU',
      baseCountryCode: 'vu',
      emoji: '🇻🇺',
      without_currency_format: 'VT{{amount}}',
    },
    {
      name: 'Tala',
      label: 'WST',
      symbol: 'WS$',
      with_currency_format: '{{amount}} WST',
      countryCodes: 'WS',
      baseCountryCode: 'ws',
      emoji: '🇼🇸',
      without_currency_format: 'WS${{amount}}',
    },
    {
      name: 'CFA Franc BEAC',
      label: 'XAF',
      symbol: 'FCFA',
      with_currency_format: '{{amount}} XAF',
      countryCodes: 'CM,CF,TD,CG,GQ,GA',
      baseCountryCode: 'cm',
      emoji: '🇨🇲',
      without_currency_format: 'FCFA{{amount}}',
    },
    {
      name: 'East Caribbean Dollar',
      label: 'XCD',
      symbol: '$',
      with_currency_format: '{{amount}} XCD',
      countryCodes: 'AI,AG,DM,GD,MS,KN,LC,VC',
      baseCountryCode: 'ai',
      emoji: '🇦🇮',
      without_currency_format: '${{amount}}',
    },
    {
      name: 'CFA Franc BCEAO',
      label: 'XOF',
      symbol: '',
      with_currency_format: '{{amount}} XOF',
      countryCodes: 'BJ,BF,CI,GW,ML,NE,SN,TG',
      baseCountryCode: 'bj',
      emoji: '🇧🇯',
      without_currency_format: '{{amount}}',
    },
    {
      name: 'CFP Franc',
      label: 'XPF',
      symbol: 'F',
      with_currency_format: '{{amount_no_decimals_with_space_separator}} XPF',
      countryCodes: 'PF,NC,WF',
      baseCountryCode: 'pf',
      emoji: '🇵🇫',
      without_currency_format: 'F{{amount_no_decimals_with_space_separator}}',
    },
    {
      name: 'Yemeni Rial',
      label: 'YER',
      symbol: '﷼',
      with_currency_format: '{{amount}} YER',
      countryCodes: 'YE',
      baseCountryCode: 'ye',
      emoji: '🇾🇪',
      without_currency_format: '﷼{{amount}}',
    },
    {
      name: 'Rand',
      label: 'ZAR',
      symbol: 'R',
      with_currency_format: '{{amount}} ZAR',
      countryCodes: 'LS,NA,ZA',
      baseCountryCode: 'ls',
      emoji: '🇱🇸',
      without_currency_format: 'R{{amount}}',
    },
    {
      name: 'Zambian Kwacha',
      label: 'ZMW',
      symbol: '',
      with_currency_format: '{{amount_no_decimals_with_comma_separator}} ZMW',
      countryCodes: 'ZM',
      baseCountryCode: 'zm',
      emoji: '🇿🇲',
      without_currency_format: '{{amount_no_decimals_with_comma_separator}}',
    },
    {
      name: 'Zimbabwe Dollar',
      label: 'ZWL',
      symbol: '',
      with_currency_format: '{{amount}} ZWL',
      countryCodes: 'ZW',
      baseCountryCode: 'zw',
      emoji: '🇿🇼',
      without_currency_format: 'Z${{amount}}',
    },
  ];